<template>
  <el-dialog
    :visible.sync="centerDialogVisible"
    :close-on-click-modal = 'false'
    :show-close ='false'
    center>
    <img class="closeimg" src="@/assets/image/close.png" @click="centerDialogVisible = false"/>
    <h2>換房</h2>
    <p style="margin-bottom: 5px">1. 請先為原始房號設定停餐日期及餐期。</p>
    <p style="margin-top: 0">2. 再設定欲更換的房號、出餐日期及餐期。</p>
    <div class="roomBody">
       <div class="original">
          <div>
            <span>原始房號</span>
            <p>{{ basicObj.agency_room_info?basicObj.agency_room_info.name:'' }}</p>
          </div>
         <div>
           <span>停餐日期</span>
           <el-date-picker
             v-model="form.date"
             type="date"
             placeholder="選擇日期"
             format="yyyy/MM/dd"
             value-format="yyyy-MM-dd"
             :picker-options="startPickerOptions"
             @change="getRoom"
           >
           </el-date-picker>
         </div>
         <div>
           <span>停餐餐期</span>
           <el-select v-model="form.stage" placeholder="請選擇餐期" @change="getRoom">
              <el-option label="早餐" :value="1"></el-option>
             <el-option label="午餐" :value="2"></el-option>
             <el-option label="晚餐" :value="3"></el-option>
           </el-select>
         </div>
       </div>
       <div style="margin: 20px 0;text-align: center">
          <img src="@/assets/image/ico23.svg"/>
       </div>
      <div class="original">
        <div>
          <span>更換房號</span>
          <el-select v-model="form.room_id"  placeholder="請選擇房號">
            <el-option v-for="(item,i) in roomList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div>
          <span>出餐日期</span>
          <el-date-picker
            v-model="form.date"
            type="date"
            placeholder="選擇日期"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            :picker-options="startPickerOptions"
            @change="getRoom"
          >
          </el-date-picker>
        </div>
        <div>
          <span>出餐餐期</span>
          <el-select v-model="form.stage" placeholder="請選擇餐期" @change="getRoom">
            <el-option label="早餐" :value="1"></el-option>
            <el-option label="午餐" :value="2"></el-option>
            <el-option label="晚餐" :value="3"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
     <div @click="centerDialogVisible = false">取消填寫</div>
      <div @click="sumbit">確認儲存</div>
  </span>
  </el-dialog>
</template>

<script>
import { changeRoom, usableRoom } from "@/api";

export default {
  name: "roomDig.vue",
  data(){
    return{
      centerDialogVisible: false,
      basicObj:{},
       form:{
         order_id: null,
         date: "",
         stage: null,
         room_id: null
       },
      room:{
        agency_id: JSON.parse(window.localStorage.getItem('agency_info')).id,
        start_date:'',
        start_stage: null,
        end_date: '',
        end_stage: ''
      },
      roomList: [],
      startPickerOptions: {
        disabledDate: (v) => {
            return (
              v.getTime() < new Date().getTime() - 8.64e7 ||
              v.getTime() > new Date(this.basicObj.end_date).getTime()
            )
        }
      },
    }
  },
  methods:{
    usableRoom(){
      this.room.start_date = this.form.date
      this.room.start_stage = this.form.stage
      usableRoom(this.room).then(res =>{
             this.roomList = res.data.list
      })
    },
    getRoom(){
       if(this.form.date && this.form.stage){
         this.usableRoom()
         this.form.room_id = null
       }else{
         this.$message.warning('請選擇停餐日期和停餐餐期獲取房間')
       }
    },
     init(item){
       this.form = {
         order_id: null,
           date: "",
           stage: null,
           room_id: null
       }
       this.basicObj = item
        this.form.order_id = item.id
       this.room.end_date = item.end_date
       this.room.end_stage = item.end_stage
        this.centerDialogVisible = true
     },
      sumbit(){
        changeRoom(this.form).then(res => {
            if(res.code == 200){
              this.$emit('done')
               this.centerDialogVisible = false
              this.$message.success('換房成功')
            }else{
              this.$message.warning(res.message)
            }
        })
      },
  }
};
</script>



<style scoped lang="scss">
::v-deep .el-dialog{
  width: 650px;
  border-radius: 15px;
  padding: 0;
  position: relative;
}
.closeimg{
  width: 30px;
  height: 30px;
  object-fit: contain;
  position: absolute;
  right: -40px;
  top: 10px;
  cursor: pointer;
}
::v-deep .el-dialog__footer{
  padding: 0;
  .dialog-footer{
     display: flex;
    align-items: center;
    div{
      flex: 1;
      background: #DBBD80;
      color: #FFFFFF;
      font-size: 20px;
      padding: 15px 20px;
      cursor: pointer;
      font-weight: bolder;
    }
    div:first-child{
      border-radius: 0 0 0 15px;
      border-right: 1px solid #FFFFFF;
    }
    div:last-child{
      border-radius: 0 0 15px 0px;
    }
  }

}

h2{
  font-size: 30px;
  font-weight: bolder !important;
  text-align: center;
  margin: 0;
  color: #DBBD80;
  padding-bottom: 20px;
  border-bottom: 1px solid #DBBD80;
}
p{
  font-size: 16px;
  color: #b6b8bd;
  text-align: start;
}

.roomBody{
   .original{
     display: flex;
     align-items: stretch;
     justify-content: space-between;
     gap: 20px;
     padding: 20px 30px;
     border: 1px solid #DBBD80;
     border-radius: 15px;

     div{
       flex: 1;
       letter-spacing: 2px;
       span{
         display: inline-block;
         padding: 5px 20px;
         background: #f5f5f5;
         border-radius: 25px;
         margin-bottom: 15px;
       }
       p{
         margin: 0;
         color: #DBBD80;
         font-size: 20px;
       }
       ::v-deep .el-input--suffix .el-input__inner{
         border:none;
       }
     }
   }
}
</style>
